<h4 class="lbl">Terms and conditions for submittal package</h4>
<textarea kendoTextArea [(ngModel)]="textValue" rows="4" cols="40" (ngModelChange)="changeTextFunction()"></textarea>
<br />
<div *ngIf="changeText">
  <button kendoButton (click)="save()">Save</button>
  <button kendoButton (click)="getTermsConditions()">Clear</button>
</div>
